<template>
  <div class="accordion" id="accordionPax">
    <div class="case-details accordion-item">
      <h2 id="headingPax" class="accordion-header">
        <button
          aria-controls="collapsePax"
          aria-expanded="true"
          class="accordion-button collapsed"
          data-bs-target="#collapsePax"
          data-bs-toggle="collapse"
          type="button"
        >
          <div class="mb-0 d-flex align-items-center">
            <div class="bg-primary rounded-xs me-8 d-flex align-items-center justify-content-center" style="width: 24px; height: 24px; flex: none;">
              <v-icon icon="group" size="xs" class="text-white" />
            </div>

            <div>
              <div class="h6 ff-secondary mb-0 fw-bold">
                {{ $t("clientTour.pax") }}
                <v-icon icon="attach" class="text-primary cursor-pointer ms-8" size="sm" @click.stop="redirect(clientTour?.activity_id)"/>
              </div>
              <div class="fw-light accordion-subtitle text-xs" style="font-size: 10px !important;">{{ $t("clientTour.paxSubtitle") }}</div>
            </div>
          </div>
        </button>
      </h2>

      <div
        id="collapsePax"
        aria-labelledby="headingPax"
        class="accordion-collapse collapse show"
        data-bs-parent="#accordionPax"
      >
        <div class="accordion-body pb-16 pb-xl-24">
          <div class="mb-0 search-separator-container">
            <div class="separator-text-container">
              <span class="text-xs separator-text fw-semi">Pax List</span>
            </div>
          </div>
          <template v-if="availablePax.length > 0">
            <div class="table-responsive mt-12 mb-12">
              <table class="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th width="40" class="text-center">#</th>
                    <th class="text-center">{{ $t("general.shared.name") }}</th>
                    <th class="text-center">{{ $t("general.shared.email") }}</th>
                    <th width="120" class="text-center">{{ $t("clientTour.rooming") }}</th>
                    <th width="80"></th>
                  </tr>
                </thead>
                <tbody class="text-xs">
                  <tr v-for="(p, index) in availablePax" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>
                      <div>
                        <template v-if="p.pax.name || p.pax.surname">
                          {{ p.pax.name }} {{ p.pax.surname || '' }}
                        </template>
                        <template v-else>
                          {{ p.pax.alias }}
                        </template>
                      </div>
                      <div v-if="!!p.pax.alias" class="text-muted fst-italic" style="font-size: 11px;">{{ p.pax.alias }}</div>
                    </td>
                    <td>{{ p.pax.email }}</td>
                    <td class="text-center">
                      <span v-if="p.room_type" class="badge bg-light text-dark">{{ formatRoomType(p.room_type) }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center align-items-center gap-4">
                        <v-icon
                          class="text-primary cursor-pointer"
                          icon="eye"
                          size="sm"
                          @click="
                            isPaxDetailshow = true;
                            selectedPax = p;
                          "
                        />
                        <v-icon
                          class="text-primary cursor-pointer"
                          icon="pencil"
                          size="sm"
                          @click="openEditPaxModal(p)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else>
            <p class="m-8 text-xs text-muted text-center italic">No pax available</p>
          </template>
          <div class="search-separator-container mb-12">
            <div class="mb-0 search-separator-container">
              <div class="separator-text-container">
                <span class="text-xs separator-text fw-semi">You can search for a pax</span>
              </div>
            </div>
            <fieldset class="mt-8">
              <v-select-pax-search
                id="case-create-client-search"
                v-model="paxId"
                :agency="agency || ''"
                :clearable="true"
                :return-object="true"
                @clear="handleClearClient"
                @update:modelValue="setPaxId"
                :case-id="clientTour?.activity_id"
                @reload-case="$emit('reloadCase')"
              />
            </fieldset>

            <div class="separator-text-container mt-12">
              <span class="separator-text text-xs">{{ $t("clientTour.sendEmail") }}</span>
            </div>
          </div>

          <div>
            <p class="text-xs text-muted mb-8">{{ $t("clientTour.paxSendEmailText") }}</p>

            <div class="d-flex">
              <v-button
                :disabled="sendingEmail"
                :is-loading="sendingEmail"
                class="btn-icon w-fit"
                size="xs"
                variant="primary"
                @click="sendEmail"
              >
                <template v-if="sendingEmail">{{ $t("general.button.sending") }}</template>
                <template v-else>{{ $t("general.button.sendEmail") }}</template>
                <v-icon icon="mail" size="xs" space="ms-8" />
              </v-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-modal
      v-if="isPaxDetailshow"
      @closed="
        selectedPax = null;
        isPaxDetailshow = false;
      "
    >
      <modal-header class="header-container">
        <h5 class="mb-0">{{ $t("general.paxDetails") }}</h5>
      </modal-header>
      <modal-body class="modalMessage">
        <table class="modalTable text-sm">
          <tbody>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrival") }}</th>
              <td>{{ selectedPax?.arrival_date || "-" }} {{ selectedPax?.arrival_hour }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrivalLocation") }}</th>
              <td>{{ selectedPax?.arrival_location || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrivalNumber") }}</th>
              <td>{{ selectedPax?.arrival_number || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrivalType") }}</th>
              <td>{{ selectedPax?.arrival_type || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.bikeType") }}</th>
              <td>{{ selectedPax?.bike_type || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrival") }}</th>
              <td>{{ selectedPax?.departure_date || "-" }} {{ selectedPax?.departure_hour }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.arrivalLocation") }}</th>
              <td>{{ selectedPax?.departure_location || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.departureNumber") }}</th>
              <td>{{ selectedPax?.departure_number || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.departureType") }}</th>
              <td>{{ selectedPax?.departure_type || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.addressStreet") }}</th>
              <td>{{ selectedPax?.pax?.address_street || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.addressCity") }}</th>
              <td>{{ selectedPax?.pax?.address_city || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.addressPostalCode") }}</th>
              <td>{{ selectedPax?.pax?.address_cp || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.addressState") }}</th>
              <td>{{ selectedPax?.pax?.address_state || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.addressCountry") }}</th>
              <td>{{ selectedPax?.pax?.address_country || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.birthDate") }}</th>
              <td>{{ selectedPax?.pax?.birth_date || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.language") }}</th>
              <td>{{ selectedPax?.pax?.language || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.allergies") }}</th>
              <td>{{ selectedPax?.pax?.allergies || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.diet") }}</th>
              <td>{{ selectedPax?.pax?.diet || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.height") }}</th>
              <td>{{ selectedPax?.pax?.height || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.weight") }}</th>
              <td>{{ selectedPax?.pax?.weight || "-" }}</td>
            </tr>
            <tr>
              <th class="bg-light">{{ $t("general.shared.holdedId") }}</th>
              <td>{{ selectedPax?.pax?.holded_id || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </modal-body>
    </v-modal>

    <the-pax-info-edit-modal
      v-if="showPaxEditModal"
      :agency="agency"
      :case-id="Number(clientTour?.id)"
      :case-traveller-id="selectedCaseTravellerId"
      :pax="selectedPaxForEdit"
      @reload-pax="onPaxUpdated"
      @closed="closePaxEditModal"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, Ref, ref, watch } from "vue";
import VModal from "@/components/vendor/basic/modal/VModal.vue";
import ModalHeader from "@/components/vendor/basic/modal/ModalHeader.vue";
import ModalBody from "@/components/vendor/basic/modal/ModalBody.vue";
import VSelectPaxSearch from "@/components/vendor/selectSearch/VSelectPaxSearch.vue";
import * as yup from "yup";
import ClientTour from "@/api/objects/ClientTour";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import api from "@/api";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import ThePaxInfoEditModal from "@/components/pax/ThePaxInfoEditModal.vue";

const props = defineProps<{
  agency: string;
  tour: number;
  clientTour: ClientTour;
  client: object;
}>();

// Define Emits
const emit = defineEmits<{
  (e: "reloadCase"): void;
}>();

const router = useRouter();
const toast = useToast();
const paxId = ref(null);
const isPax = ref(false);
const availablePax: Ref<any[]> = ref([]);
const paxFields: Ref<any[]> = ref([]);
const paxErrors: Ref<any[]> = ref([]);
const isSaving = ref(false);

const formatRoomType = (roomType: string): string => {
  if (!roomType) return "";
  return roomType
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const sortPax = (a: any, b: any) => {
  const nameA = (a.pax?.name || a.traveller?.name || a.name || '').toLowerCase();
  const nameB = (b.pax?.name || b.traveller?.name || b.name || '').toLowerCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  const idA = a.traveller_id || a.pax?.id || a.id || 0;
  const idB = b.traveller_id || b.pax?.id || b.id || 0;
  return idA - idB;
};
const sendingEmail = ref(false);
const selectedPax: Ref<any> = ref(null);
const isPaxDetailshow = ref(false);
const showPaxEditModal = ref(false);
const selectedPaxForEdit: Ref<any> = ref(null);
const selectedCaseTravellerId: Ref<number | null> = ref(null);

const openEditPaxModal = (p: any) => {
  // Merge traveller data with case-traveller meta fields so the modal can edit both
  const traveller = p?.pax || p;
  selectedPaxForEdit.value = {
    ...traveller,
    // Case-traveller meta fields (flight info, bike, observations, etc.)
    bike_type: p?.bike_type ?? '',
    room_type: p?.room_type ?? '',
    observations: p?.observations ?? '',
    arrival_type: p?.arrival_type ?? null,
    arrival_number: p?.arrival_number ?? '',
    arrival_date: p?.arrival_date ?? '',
    arrival_hour: p?.arrival_hour ?? '',
    arrival_location: p?.arrival_location ?? '',
    departure_type: p?.departure_type ?? null,
    departure_number: p?.departure_number ?? '',
    departure_date: p?.departure_date ?? '',
    departure_hour: p?.departure_hour ?? '',
    departure_location: p?.departure_location ?? '',
  };
  selectedCaseTravellerId.value = p?.id ?? null;
  showPaxEditModal.value = true;
};

const closePaxEditModal = () => {
  showPaxEditModal.value = false;
  selectedPaxForEdit.value = null;
  selectedCaseTravellerId.value = null;
};

const onPaxUpdated = () => {
  emit("reloadCase");
};

const paxSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
  email: yup.string().trim().required("Email is required").email("Email must be a valid email"),
});

const validatePax = async () => {
  let valid = true;
  paxErrors.value = [];

  for (const [index, p] of paxFields.value.entries()) {
    try {
      await paxSchema.validate(p.pax, { abortEarly: false });
      paxErrors.value[index] = {}; // no errors
    } catch (validationError: any) {
      valid = false;
      const fieldErrors: Record<string, string> = {};
      validationError.inner.forEach((err: any) => {
        fieldErrors[err.path] = err.message;
      });
      paxErrors.value[index] = fieldErrors;
    }
  }

  return valid;
};

onMounted(() => {
  if (props.clientTour?.paxes && Array.isArray(props.clientTour.paxes)) {
    availablePax.value = [...props.clientTour.paxes].sort(sortPax);
  } else {
    availablePax.value = [];
    paxErrors.value = [];
    isPax.value = false;
  }
});

watch(
  () => props.clientTour?.paxes,
  (newPaxes) => {
    if (Array.isArray(newPaxes)) {
      availablePax.value = [...newPaxes].sort(sortPax);
    } else {
      availablePax.value = [];
      paxErrors.value = [];
      isPax.value = false;
    }
  },
  { immediate: false, deep: true }
);

const setPaxId = async (val: any) => {
  if (!val) return;

  paxFields.value.push({
    pax: {
      name: val.name || "",
      email: val.email || "",
      id: val.id,
    },
  });
  paxErrors.value.push({});
  paxId.value = null; // clear input after adding
  isPax.value = true;
};

const handleClearClient = () => {
  paxId.value = null; // clears v-select correctly
};

const sendEmail = async () => {
  sendingEmail.value = true;
  try {
    const payload = {
      name: props?.client?.name,
      email: props?.client?.email,
    };
    await api.case.caseSendNotificationClient(props.agency, Number(props.clientTour?.id), payload);
    toast.success("Email sent successfully");
    emit("reloadCase");
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Error sending email");
  } finally {
    sendingEmail.value = false;
  }
};

const redirect = (caseId: string | number) => {
  router.push({
    name: "pax.index",
    query: { case_id: caseId },
  });
}
</script>

<style lang="scss" scoped>
.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
  padding: 0.5rem 1rem !important;
}

.modalTable {
  width: 100%;
  border-collapse: collapse;
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  th {
    width: 40%;
    text-align: left;
  }
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
